import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Select, SelectOption, SelectSize } from '@/components/ui/select'
import { getPlaceName } from '@/pages/organisation/places/places.utils'
import { selectBuildings } from '@/reducers/buildingSelectorReducer'

interface BuildingsSelectProps {
  error?: string
  label?: string
  placeholder: string
  required?: boolean
  size?: SelectSize
  value: number[]
  withReservedFooter?: boolean
  onChange: (value: number[]) => void
  onReset?: VoidFunction
}

export const BuildingsSelect = ({
  error,
  label,
  placeholder,
  required,
  size = 'medium',
  value,
  withReservedFooter,
  onChange,
  onReset,
}: BuildingsSelectProps) => {
  const { t } = useTranslation(['organisation'])
  const buildings = useSelector(selectBuildings)

  const options = useMemo<SelectOption<number>[]>(
    () => buildings.map((building) => ({ label: getPlaceName(building), value: building.id })),
    [buildings],
  )

  return (
    <Select
      searchable
      type="multi"
      error={error}
      label={label}
      options={options}
      placeholder={placeholder}
      required={required}
      searchPlaceholder={t('organisation:bookingTypes.buildings.searchPlaceholder')}
      size={size}
      value={value}
      withReservedFooter={withReservedFooter}
      onChange={onChange}
      onReset={onReset}
    />
  )
}
